/**
 * @author Fernando Ruano
 * @file index.js
 * @description Modal Input Educational Material Component
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal, Input, Button } from 'antd';
import styled from 'styled-components';
import { PlusCircleFilled, FolderAddOutlined } from '@ant-design/icons';

// Components
import ButtonFilled from '@nephro/components/ButtonFilled';

const CancelButton = styled(Button)`
  width: 100%;
  height: 40px;
  font-weight: bold;
  font-size: 14px;
`;

/**
 * Modal Input Educational Material Component.
 * @return { Node } React Modal Input Educational Material Component
 */
const ModalInputsEM = ({
  visible,
  setVisible,
  inputValue,
  setInputValue,
  onActionConfirm,
  validateInput,
  type,
  title,
  inputLabel
}) => {
  const { t: translate } = useTranslation();
  const icon =
    type === 'category' ? (
      <PlusCircleFilled
        style={{ color: 'var(--color-baxter-teal-medium)', fontSize: 87 }}
      />
    ) : (
      <FolderAddOutlined
        style={{ color: 'var(--color-baxter-teal-medium)', fontSize: 87 }}
      />
    );
  return (
    <Modal visible={visible} title="" closable={false} footer={null}>
      <div className="text-center py-10 md:px-10">
        {icon}
        <h2 className="mb-0 mt-4 text-2xl font-medium text-baxterGray">
          {title}
        </h2>
        <h2 className="mb-2 mt-7 text-base text-baxterGray text-left">
          {inputLabel}
        </h2>
        <Input
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </div>
      <div className="w-full flex flex-row justify-center mt-3 md:px-10">
        <CancelButton onClick={() => setVisible(false)} type="link">
          {translate('commons.cancel')}
        </CancelButton>
        <ButtonFilled
          disabled={validateInput}
          key="submit"
          type="cyan"
          textButton={translate('commons.confirm')}
          classStyles={[`${validateInput && 'opacity-40'} font-bold`].join(' ')}
          onActionClick={onActionConfirm}
        />
      </div>
    </Modal>
  );
};

/**
 * @name ModalInputsEM.propTypes
 * @type { Object }
 */
ModalInputsEM.propTypes = {
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  validateInput: PropTypes.bool,
  inputValue: PropTypes.string,
  title: PropTypes.string,
  inputLabel: PropTypes.string,
  setInputValue: PropTypes.func,
  onActionConfirm: PropTypes.func,
  type: PropTypes.string
};

/**
 * Default props
 */
ModalInputsEM.defaultProps = {
  icon: null,
  visible: false
};

export default ModalInputsEM;
